import { FC, Fragment, useState } from 'react';
import { Button } from '@servicetitan/design-system';
import { OutboundCallModalProvider } from '../OutboundCallModal';
import OutboundCallModal from '../OutboundCallModal/OutboundCallModal';
import { mainLayoutLocators } from '@locators/main-layout';
import { FeatureErrorBoundary } from '@components/ErrorBoundary';

export const OutboundCallButton: FC = () => {
  const [showOutboundCallModal, setShowOutboundCallModal] = useState(false);

  const toggleOutboundCallModal = () => {
    setShowOutboundCallModal((state) => !state);
  };

  return (
    <Fragment>
      <Button
        id={mainLayoutLocators.navBar.callBtnIcon}
        iconName='phone_outbound'
        outline
        size='small'
        width='full'
        onClick={toggleOutboundCallModal}
      >
        Make a Call
      </Button>

      {showOutboundCallModal && (
        <FeatureErrorBoundary featureName='Outbound Call Modal' size='full'>
          <OutboundCallModalProvider>
            <OutboundCallModal
              open={showOutboundCallModal}
              setOpen={setShowOutboundCallModal}
              showTenantSelection
            />
          </OutboundCallModalProvider>
        </FeatureErrorBoundary>
      )}
    </Fragment>
  );
};
